import Dialog from "dialog";
import template from "../html/dialog-config-pump-feed.html";
import css from "../css/dialog-config-pump-feed.css";

class ConfigFeedPumpDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-pump-feed", ConfigFeedPumpDialog);
	}
	constructor() {
		super();

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	connectedCallback() {
		super.connectedCallback();

		this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
		document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

		this.onupdatedevices_handler({detail: application.devices});

		this.spinnerTargetRPM.value = this.textboxCurrentRPM.value;
		this.spinnerTargetMLH.value = this.textboxCurrentMLH.value;
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
	}
	buttonClose_click(event) {
		this.close();
	}
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.feedPump.id;
		this.textboxDeviceStatus.value = devices.feedPump.status;
		this.textboxCurrentRPM.value = devices.feedPump.rpm;
		this.textboxCurrentMLH.value = devices.feedPump.mlh;
		this.textboxCalibrationStatus.value = devices.feedPump.calibrationStatus;
	}
	spinnerTargetRPM_change(event) {
		server.rcall("RM_feedpump_setRPM", this.spinnerTargetRPM.value).catch(function(result) {
			alert(result);
		});
	}
	spinnerTargetMLH_change(event) {
		server.rcall("RM_feedpump_setMLH", this.spinnerTargetMLH.value).catch(function(result) {
			alert(result);
		});
	}
	buttonCalibrate_click(event) {
		this.iconCalibrate.iconname = "view-refresh";
		server.rcall("RM_feedpump_calibrate", this.spinnerCalibrationRPM.value, this.spinnerCalibrationMLH.value).then(function(result) {
			this.iconCalibrate.iconname = "dialog-ok-apply";
		}.bind(this)).catch(function(result) {
			this.iconCalibrate.iconname = "process-stop";
		}.bind(this));
	}
}

ConfigFeedPumpDialog.constructor();

export default ConfigFeedPumpDialog;